module.exports = __webpack_public_path__ + "app-static/img/kkcg.b4dafbb2.png";